export const areas = {
    previdenciario: {
        id: 5
    },
    trabalhista: {
        id: 2
    }
}